import { render, staticRenderFns } from "./PackageDetails.vue?vue&type=template&id=3f1ffe35"
import script from "./PackageDetails.vue?vue&type=script&lang=ts"
export * from "./PackageDetails.vue?vue&type=script&lang=ts"
import style0 from "./PackageDetails.vue?vue&type=style&index=0&id=3f1ffe35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports